import Vue from "vue";
import VueRouter from "vue-router";

import ResultScreen from "../views/ResultScreen";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "Home",
    meta: {
      title: "Início",
    },
    component: () => import(/* webpackChunkName: "home" */ "../views/Home"),
  },
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/cadastro" /* dados iniciais */,
    name: "FormScreenData",
    meta: {
      title: "Dados",
    },
    component: () =>
      import(
        /* webpackChunkName: "formScreenData" */ "../views/FormScreenData"
      ),
  },
  {
    path: "/questionario" /* quiz screen */,
    name: "QuizScreen",
    meta: {
      title: "Questionario",
    },
    component: () =>
      import(/* webpackChunkName: "quizScreen" */ "../views/QuizScreen"),
  },
  {
    path: "/resultado" /* quiz screen */,
    name: "ResultScreen",
    meta: {
      title: "Resultado",
    },
    component: ResultScreen,
  },
  {
    path: "/dicas",
    name: "Dicas de saúde",
    meta: {
      title: "Dicas de saúde",
    },
    component: () =>
      import(/* webpackChunkName: "healthTips" */ "../views/HealthTips"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | MentalPro`;
  next();
});

export default router;
